import { render, staticRenderFns } from "./qna_write.vue?vue&type=template&id=5ecbead1&"
import script from "./qna_write.vue?vue&type=script&lang=js&"
export * from "./qna_write.vue?vue&type=script&lang=js&"
import style0 from "./qna_write.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports